import { render, staticRenderFns } from "./active-delivery-order.pug?vue&type=template&id=5cdbd192&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../active-order/active-order.scss?vue&type=style&index=0&id=5cdbd192&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdbd192",
  null
  
)

export default component.exports